import { RView1jxdnn5qf89cm as RView } from '../RView.commonHtml.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var ActivityIndicatorClass;
function ActivityIndicator() {
  if (ActivityIndicatorClass === VOID) {
    class $ extends RView() {
      constructor(context) {
        super(context);
        this.tb5_1.xb3_1 = 'span';
        this.tb5_1.hb4_1.v('spinner');
      }
    }
    initMetadataForClass($, 'ActivityIndicator');
    ActivityIndicatorClass = $;
  }
  return ActivityIndicatorClass;
}
//region block: exports
export {
  ActivityIndicator as ActivityIndicatork1oa7i2hevyv,
};
//endregion

//# sourceMappingURL=ActivityIndicator.commonHtml.mjs.map
